/**
 * Dispatcher for Account Settings app.
 */
import AppDispatcher from 'bundles/phoenix/lib/AppDispatcher';

export default new AppDispatcher();
